if (!document.querySelector("body").classList.contains('login')){
    let smoother = ScrollSmoother.create({
        smooth: 1,
        effects: true,
    });
}


/////////////////////// QUERY RESIZE /////////////////////
let mq980 = window.matchMedia("(min-width: 980px)");

/////////////////////// FUNCION PARA AÑADIR EN EL CASO DE QUE TENGA QUE SALTAR AL HACER RESIZE /////////////////////
function match() {
    /////////////////////// PARA QUE NO SE CIERREN LOS TABS EN DESKTOP /////////////////////
    if (mq980.matches) {
        document.querySelectorAll('.acc-tabsnav .btn-dek').forEach(b => {
            b.addEventListener('click', () => {
                document.querySelectorAll('.tab-content .body-coll').forEach(c => {
                    if (c.attributes["aria-labelledby"].value == b.id) {
                        c.classList.add('show')
                    }
                })
            })
        })
        document.querySelector('.nav-header').style.translate = "";
    }

    /////////////////////// CUANDO SE HAGA RESIZE SI EL MENU ESTA ABIERTO QUE SE CIERRE /////////////////////
    document.querySelectorAll('.menuC').forEach(m => {
        $(m).collapse("hide");
        if (m.previousElementSibling.classList.contains('active')) {
            m.previousElementSibling.classList.remove('active')
        }
    })
    if (!document.querySelector('#menuMob').classList.contains('show')) {
        document.body.classList.remove('no-scroll')
    }
}

/////////////////////// LISTENER RESIZE /////////////////////

let showAnim
/////////////////////// FUNCION STATIC HEADER SOLO EN TABLET Y MOVIL /////////////////////
if (!document.querySelector(".nav-header").classList.contains('nav-log')){
    showAnim = gsap.from('.nav-header', {
        yPercent: -120,
        paused: true,
        duration: 0.6,
        ease: "power2.out"
    }).progress(1);
} 


let dateElements = document.querySelectorAll(".js-date-timeline");
if(dateElements.length) {
    ScrollTrigger.matchMedia({
        "(min-width: 740px)": function () {
            const triangle = document.querySelector('.tirangle');
            const background = document.querySelector('.cont-time-line .background');
            const contTimeLine = document.querySelector('.cont-time-line');
            // BACKGROUND
            gsap.to(triangle, {
              scrollTrigger: {
                trigger: document.querySelector('.cont-triangle'),
                start: '2px top',
                end: 'bottom bottom',
                scrub: true,
                pin: true,
                // markers: true
              },
            });
            gsap.to(background, {
              scrollTrigger: {
                trigger: document.querySelector('.cont-back'),
                start: 'top top',
                end: 'bottom bottom',
                scrub: true,
                pin: true,
                // markers: true
              },
            });
    
            dateElements.forEach((dateElement, i) => {
                
                /// POINT ///
                gsap.from(dateElement.querySelector('.point'), {
                    duration: 0.2,
                    opacity: 0,
                    scale: 0,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: dateElement.querySelector('.point'),
                        start: "top 80%",
                        end: "top top",
                        // markers: true,
                        toggleActions: "play reverse play reverse",
                        // scrub: true,
                    }
                })
    
                /// INFOS ///
                if (i === dateElements.length - 1) {
                    gsap.fromTo(dateElement.querySelector('.info'), {
                        opacity: 0,
                        y: 50,
                    }, {
                        opacity: 1,
                        y: 0,
                        scrollTrigger: {
                            trigger: dateElement.querySelector('.info'),
                            start: " 80% top",
                            end: "top 40%",
                            // markers: true,
                            toggleActions: "play reverse play reverse",
                            ease: "power1.out",
                            scrub: true,
                        }
                    })
                }
                if (dateElement.querySelector('.img')) {
                    gsap.fromTo(dateElement.querySelector('.img'), {
                        yPercent: 50,
                        
                        },{
                        yPercent: -100,
                        scrollTrigger: {
                            trigger: dateElement.querySelector('.cont-date'),
                            start: "top bottom",
                            end: "bottom top",
                            // markers: true,
                            toggleActions: "play reverse play reverse",
                            scrub: 3,
                            ease: "power2.out"
                        }
                    })
                }
            })
        },
        "(min-width: 740px) and (max-width: 979px)": function () {
            dateElements.forEach((dateElement, i) => { 
                gsap.fromTo(dateElement.querySelector('.info'), {
                    opacity: 0,
                    x: 50,
                }, {
                    opacity: 1,
                    x: 0,
                    scrollTrigger: {
                        trigger: dateElement.querySelector('.info'),
                        start: " 80% top",
                        end: "top 40%",
                        // markers: true,
                        toggleActions: "play reverse play reverse",
                        ease: "power1.out",
                        scrub: true,
                    }
                })
            })
        },
        "(min-width: 980px)": function () {
            dateElements.forEach((dateElement, i) => {
               
                if(dateElement.classList.contains('left')) {
                    gsap.fromTo(dateElement.querySelector('.info'), {
                        opacity: 0,
                        x: 50, 
                    },{
                        opacity: 1,
                        x: 0, 
                        scrollTrigger: { 
                            trigger: dateElement.querySelector('.info'),
                            start:" 80% top",
                            end: "top 40%",
                            // markers: true,
                            toggleActions: "play reverse play reverse", 
                            ease: "power1.out",
                            scrub: true,
                        }
                    })
                }
                if (dateElement.classList.contains('right')) {
                    gsap.fromTo(dateElement.querySelector('.info'), {
                        opacity: 0,
                        x: -50,
                    }, {
                        opacity: 1,
                        x: 0,
                        scrollTrigger: {
                            trigger: dateElement.querySelector('.info'),
                            start: " 80% top",
                            end: "top 40%",
                            //markers: true,
                            toggleActions: "play reverse play reverse",
                            ease: "power1.out",
                            scrub: true,
                        }
                    })
                }
            })
        }
    })
}
window.addEventListener('resize', () => {
    match()
    if(document.querySelector(".cont-time-line .line")) {
        let lastIndice = document.querySelectorAll('.js-date-timeline').length -1
        let lastEl = document.querySelectorAll('.js-date-timeline')[lastIndice]
        let resta = document.querySelector('.cont-time-line .position-relative').offsetHeight - lastEl.offsetHeight
        document.querySelector(".cont-time-line .line").style.height = resta + "px";
    }
});

if(document.querySelector('.cards-sticky')) {
    document.querySelectorAll('.cards-sticky').forEach((el) => {
        let hC = el.offsetHeight;
        if(!el.classList.contains('col-sm-12')) {
            // console.log('no col-sm-12',!el.classList.contains('col-sm-12'));
            ScrollTrigger.matchMedia({
                "(min-width: 740px)": function () {
                    gsap.to(el, {
                        scrollTrigger: {
                            trigger: el.parentElement,
                            pin: el,
                            start: "top top",
                            end: "bottom "+ hC + "px",
                            scrub: 3,
                            pinSpacing: false
                        }
                    });
                },
            })
        } else if(!el.classList.contains('col-md-12')) {
            //console.log('no col-md-12',!el.classList.contains('col-md-12'));
            ScrollTrigger.matchMedia({
                "(min-width: 980px)": function () {
                    gsap.to(el, {
                        scrollTrigger: {
                            trigger: el.parentElement,
                            pin: el,
                            start: "top top",
                            end: "bottom "+ hC + "px",
                            pinSpacing: false,
                            scrub: 3,
                        }
                    });
                },
            })
        }
    })
}


ScrollTrigger.matchMedia({
    "(max-width: 979px)": function () {
        let tl = gsap.timeline({
            scrollTrigger: {
                start: "top+=160px",
                onUpdate: (self) => {
                    document.querySelectorAll(".menuC ").forEach(c => {
                        if (c.classList.contains('show')) {
                            c.classList.remove('show')
                        }
                    })
                    /*if(document.querySelector('.btn-mobil')) {
                        if(!document.querySelector('.btn-mobil').classList.contains('collapsed')) {
                            document.querySelector('.btn-mobil').classList.add('collapsed')
                        }
                    }*/
                    if (self.direction === -1) {
                        showAnim.play()
                        document.querySelector('.nav-header').classList.add('static');
                    } else if (self.direction === 1 && document.querySelector('.btn-mobil').classList.contains('collapsed')) {
                        showAnim.reverse();
                    }
                },
                onLeaveBack: () => {
                    setTimeout(() => {
                        document.querySelector('.nav-header').classList.remove('static');
                        showAnim.play();
                    }, 50);
                    showAnim.reverse();
                }
            }
        })
    },
    "(min-width: 980px)": function () {
        let desktop = gsap.timeline({
            onComplete: removeStatic,
        })
    }
})
function removeStatic() {
    if (document.querySelector('.nav-header').classList.contains('static')) {
        document.querySelector('.nav-header').classList.remove('static');
        document.querySelector('.nav-header').style.transform = "";
    }
}
if (document.querySelector(".cont-time-line .line")) {
   let lastIndice = document.querySelectorAll('.js-date-timeline').length - 1;
   let lastEl = document.querySelectorAll('.js-date-timeline')[lastIndice];
   let resta = document.querySelector('.cont-time-line .position-relative').offsetHeight - lastEl.offsetHeight;
   document.querySelector(".cont-time-line .line").style.height = resta + "px";
}

/////////////////////// EMPIEZA FUNCION CALCOXITEMPS /////////////////////

/////////////////////// HABILITAR O DESHABILITAR CHECKBOX  /////////////////////
let checklpm = document.getElementById('oxitemps_checklpm');
let lpmdisabled = document.getElementById('oxitemps_lpm');
if (!checklpm) {
    checklpm = document.getElementById('checklpm');
    lpmdisabled = document.getElementById('lpm');
}
if (checklpm) {
    checklpm.addEventListener('change', () => {
        if (checklpm.checked === true) {
            lpmdisabled.disabled = true
            lpmdisabled.parentElement.classList.add('disabled')
        } else {
            lpmdisabled.disabled = false;
            lpmdisabled.parentElement.classList.remove('disabled')
        }
    })
}

/////////////////////// FUNCION CALCULAR OXITEMPS Y CREAR GRAFICA /////////////////////
let myChart;
let labels;


if (window.location.pathname == '/es/oxitemps' && document.getElementById('oxitemps_litros').value !== 0 &&
    document.getElementById('oxitemps_bares').value !== 0 &&
    document.getElementById('oxitemps_lpm').value !== 0) {

    calcAutoparams(this);
}



function calcAutoparams(el) {

    let litro = Math.floor(document.getElementById('oxitemps_litros').value),
        bares = Math.floor(document.getElementById('oxitemps_bares').value),
        lpm = Math.floor(document.getElementById('oxitemps_lpm').value),
        check = document.getElementById('oxitemps_checklpm').checked;
    if (check) {
        lpm = 100;
        document.getElementById('oxitemps_lpm').disabled = true;
    } else {
        lpm = Math.floor(document.getElementById('oxitemps_lpm').value);
    }
    let autonomyMinutes = (((litro * 0.21 * bares) / lpm) * 0.0825) * 60;
    let m = Math.floor(autonomyMinutes % 60);
    let h = Math.floor(autonomyMinutes / 60);
    document.getElementById('hOxi').innerText = h;
    document.getElementById('mOxi').innerText = m;

    document.getElementById('litrosText').innerText = litro;
    document.getElementById('lpmText').innerText = lpm;

    labels = [
        '300 bares',
        '200 bares',
        '175 bares',
        '150 bares',
        '125 bares',
        '100 bares',
        '75 bares',
        '50 bares',
        '25 bares',
    ];

    let labelsMin = [];
    labels.forEach((label) => {
        let numLabel = parseInt(label.split(' ')[0])
        numbers = Math.floor((((litro * 0.21 * numLabel) / lpm) * 0.0825) * 60);
        labelsMin.push(numbers)
    })

    const data = {
        labels: labels,
        datasets: [{
            label: 'Tiempo estimado',
            backgroundColor: '#385fa4',
            data: labelsMin,
        }]
    };

    const config = {
        type: 'bar',
        data: data,
        options: {
            maintainAspectRatio: false,
            scales: {
                y: {
                    stacked: true,
                    grid: {
                        display: true,
                    }
                },
                x: {
                    grid: {
                        display: false
                    }
                },
            },
            plugins: {
                legend: {
                    position: 'right',
                    align: 'start',
                },
            },
            indexAxis: 'y',
        }
    }
    if (autonomyMinutes > 0) {
        document.querySelector('.cont-chart').classList.add('show');
        document.querySelector('.cont-hide').classList.remove('show');
    }
    myChart = new Chart(
        document.getElementById('chartOxi'),
        config
    );
}

function revAuto(el) {
    // console.log('holi2')
    let litro = Math.floor(document.getElementById('litros').value),
        bares = Math.floor(document.getElementById('bares').value),
        lpm = Math.floor(document.getElementById('lpm').value),
        check = document.getElementById('checklpm').checked;
    check === true ? lpm = 100 : Math.floor(document.getElementById('lpm').value);


    if (litro !== 0 && bares !== 0 && lpm !== 0) {
        document.theForm.submit();

    } else {
        if (document.getElementById('errorCalc')) {
            document.getElementById('errorCalc').style.display = 'flex'
        }
        if (document.querySelector(".cont-hide") != null) {
            document.querySelector('.cont-hide').classList.add('show');
        }
        document.querySelector('.form-card').addEventListener('submit', (e) => {
            e.preventDefault();
        })
    }
}
function calcAuto(el) {
    // console.log('3')

    let litro = Math.floor(document.getElementById('oxitemps_litros').value),
        bares = Math.floor(document.getElementById('oxitemps_bares').value),
        lpm = document.getElementById('oxitemps_lpm').value,
        check = document.getElementById('oxitemps_checklpm').checked;
    check === true ? lpm = 100 : lpm;

    if (litro !== 0 && bares !== 0 && lpm !== 0) {
        if (document.getElementById('errorCalc')) {
            document.getElementById('errorCalc').style.display = '';
        }

        if (myChart !== undefined) {
            myChart.destroy();
        }

        check === true ? lpm = 100 : lpm;
        // let autonomyMinutes = (((litro * 0.21 * bares) / lpm) * 0.0825) * 60;
        let autonomyMinutes = (litro * bares) / lpm; 
        let m = Math.floor(autonomyMinutes % 60);
        let h = Math.floor(autonomyMinutes / 60);

        if (document.querySelector('.cont-chart') && litro != 0 && bares != 0 && lpm != 0) {

            document.getElementById('hOxi').innerText = h;
            document.getElementById('mOxi').innerText = m;

            document.getElementById('litrosText').innerText = litro;
            document.getElementById('lpmText').innerText = lpm;

            labels = [
                '300 bares',
                '200 bares',
                '175 bares',
                '150 bares',
                '125 bares',
                '100 bares',
                '75 bares',
                '50 bares',
                '25 bares',
            ];

            let labelsMin = [];
            labels.forEach((label) => {
                let numLabel = parseInt(label.split(' ')[0])
                numbers = Math.floor((((litro * 0.21 * numLabel) / lpm) * 0.0825) * 60);
                labelsMin.push(numbers)
            })

            const data = {
                labels: labels,
                datasets: [{
                    label: 'Tiempo estimado',
                    backgroundColor: '#385fa4',
                    data: labelsMin,
                }]
            };

            const config = {
                type: 'bar',
                data: data,
                options: {
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            stacked: true,
                            grid: {
                                display: true,
                            }
                        },
                        x: {
                            grid: {
                                display: false
                            }
                        },
                    },
                    plugins: {
                        legend: {
                            position: 'right',
                            align: 'start',
                        },
                    },
                    indexAxis: 'y',
                }
            }
            if (document.querySelector(".cont-chart") != null) {
                document.querySelector('.cont-chart').classList.add('show');
            }
            if (document.querySelector(".cont-hide") != null) {
                document.querySelector('.cont-hide').classList.remove('show');
            }
            myChart = new Chart(
                document.getElementById('chartOxi'),
                config
            );
        }
    } else {
        if (document.querySelector('.cont-chart') != null) {
            if (document.querySelector('.cont-chart').classList.contains('show')) {
                document.querySelector('.cont-chart').classList.remove('show');
                document.querySelector('.cont-hide').classList.add('show');
            }
        }
        document.getElementById('errorCalc').style.display = 'flex'
    }
}
/////////////////////// FIN FUNCION CALCOXITEMPS /////////////////////


///////////////////////QUE SE VEAN AL DESPLEGAR EL NAV HOME LAS LISTAS LAS PRIMERAS /////////////////////
document.querySelectorAll('#menuO .nav-primary__drop').forEach(b => {
    b.addEventListener('click', () => {
        if (mq980.matches) {
            const idC = b.getAttribute('data-bs-target');
            const elId = document.getElementById(idC.slice(1));
            const colEl = elId.querySelector('.col-md-3 .list-nav li:first-child button');
            if (colEl.classList.contains('collapsed')) {
                colEl.click();
            }
        }
    })
})
/////////////////////// DESPLEGABLE HEADER SEARCH DESKTOP /////////////////////
if (document.getElementById('hfs-open')!= null){
   document.getElementById('hfs-open').addEventListener('click', function () {
        document.getElementById('hfs-open').closest('.header-search-form').classList.add('open');
    })
    document.getElementById('hfs-open').addEventListener('mouseenter', function () {
        document.getElementById('hfs-open').closest('.header-search-form').classList.add('open');
    })
    document.querySelector('.header-search-form').addEventListener('mouseleave', function () {
        if (document.querySelector('.header-search-form .form-control') !== document.activeElement) {
            document.querySelector('.header-search-form').classList.remove('open');
        }
    })
    document.querySelector('.header-search-form .form-control').addEventListener('blur', function () {
        if (document.querySelector('.header-search-form .btn') !== document.activeElement) {
            document.querySelector('.header-search-form').classList.remove('open');
        }
    })
    document.getElementById('input-search').addEventListener('change', function () {
        if (document.getElementById('input-search').value !== '') {
            document.getElementById('header-search').style.pointerEvents = "auto";
        } else {
            document.getElementById('header-search').style.pointerEvents = '';
        }
    })
}


/////////////////////// CLOSE MOVIL SUBMENUS /////////////////////
if (document.querySelector('#menuMob.menuC')!= null){
    document.querySelector('#menuMob.menuC').addEventListener('show.bs.collapse', event => {
        if (!mq980.matches) {
            document.body.classList.add('no-scroll')
        }
    })
}
if (document.getElementById('menu-mobil')!= null){
document.querySelector('#menu-mobil').addEventListener('click', function () {
    if (!mq980.matches) {
        setTimeout(() => {
            if (!document.querySelector('#menuMob').classList.contains('show')) {
                document.body.classList.remove('no-scroll')
            }
        }, 500);
        document.querySelectorAll('#menuMob button.nav-primary__drop').forEach(m => {
            setTimeout(() => {
                if (!m.classList.contains('collapsed')) {
                    m.click();
                }
            }, 300);
        })
    }
})
}


document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.btn-up')!= null){
        document.querySelector('.btn-up').addEventListener('click', ()=> {
            document.body.scrollTop = 0;        
              document.documentElement.scrollTop = 0; 
        })
    }
    match();
    // timelineDesk();
    // timelineTablet();
    if (document.querySelector("p")!= null){
        let pArray = document.querySelectorAll("p");
        pArray.forEach(function (el, index) {
            el.innerHTML = el.innerHTML.replaceAll("OXIGEN salud", "<strong style='color:#1d186a;'><span class='black'>OXIGEN</span> salud</strong>");
        });
    }

    if ($(".counter_n").length) {
        $('.counter_n').counter();
    }

    /////////////////////// VIDEO /////////////////////
    if ($(".vlite-js").length) {
        Vlitejs.registerProvider('youtube', VlitejsYoutube);
        $(".vlite-js").each(function () {
            $vId = $(this).attr('id');
            $pId = $(this).attr('poster');
            if ($(this).hasClass('ytb')) {
                new Vlitejs('#' + $vId, {
                    provider: 'youtube',
                    options: {
                        autoplay: false,
                        controls: true,
                        poster: $pId,
                    },
                    providerParams: {
                        rel: 0,
                        showinfo: 0
                    }
                });
            } else {
                new Vlitejs('#' + $vId, {
                    options: {
                        autoplay: false,
                        controls: true,
                        poster: $pId,
                    }
                });
            }
        });
    }
    /////////////////////// INICIALIACION SWIPER /////////////////////

    let swiperBan = new Swiper(".swiper-banner", {
        loop: true,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
            enabled: true,
        },
        pagination: {
            el: ".swiper-pagination",
        },
    });

    if ($('.swiper-gallery').length) {
        let $sgal = 0;
        $(".swiper-gallery").each(function () {
            let sGall = {};
            $(this).addClass('swiper-gallery' + $sgal).data('count', $sgal);
            sGall[$sgal] = new Swiper('.swiper-gallery' + $sgal, {
                autoHeight: false,
                setWrapperSize: false,
                pagination: {
                    el: '.sg-pagination',
                    type: 'bullets',
                },
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 20,
                centeredSlides: false,
                loop: false,
                keyboard: {
                    enabled: true
                },
                preloadImages: false,
                lazy: {
                    loadPrevNext: false,
                    elementClass: 'swiper-lazy'
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Mostrar imagen anterior',
                    nextSlideMessage: 'Mostrar imagen siguiente',
                    firstSlideMessage: 'Es la primera imagen ganador',
                    lastSlideMessage: 'Es la última imagen ganador',
                    paginationBulletMessage: 'Mostrar imagen {{index}}',
                },
                navigation: {
                    nextEl: '.sg-next',
                    prevEl: '.sg-prev',
                },
                breakpoints: {
                    // when window width is >= 480px
                    560: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    },
                    760: {
                        slidesPerView: 4,
                        slidesPerGroup: 4
                    },
                },
                init: false
            });
            sGall[$sgal].on('init', function () {
                $('.swiper-gallery' + $sgal).addClass('ready');
            }).init();
            $sgal = $sgal + 1;
        });
    }
    let swiperH = new Swiper(".swiper-header", {
        effect: 'fade',
        loop: true,
        autoplay: {
            delay: 6000,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 3
        },
        navigation: {
            nextEl: ".swiper-button-next",
        },
        on: {
            init: function (e) {
                for (let i = 0; i < e.wrapperEl.children.length; i++) {
                    if (e.wrapperEl.children[i].classList.contains('swiper-slide-active') && e.wrapperEl.children[i].classList.contains('green-light')) {
                        document.querySelector('.swiper-button-next').style.backgroundColor = '#93cf50';
                        document.querySelector('.swiper-button-next').style.setProperty("--s-color", "");
                        document.querySelector('.swiper-cont-next').style.setProperty('--s-color', '');
                        if(document.querySelector('.swiper-pagination-bullet')) {
                            document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
                                b.classList.contains('swiper-pagination-bullet-active') ? b.style.backgroundColor = '#93cf50' : b.style.backgroundColor = '';
                            })
                        }
                    } else if (e.wrapperEl.children[i].classList.contains('swiper-slide-active') && e.wrapperEl.children[i].classList.contains('green-dark')) {
                        document.querySelector('.swiper-button-next').style.backgroundColor = '#93cf50';
                        document.querySelector('.swiper-button-next').style.setProperty("--s-color", "#ffffff");
                        document.querySelector('.swiper-cont-next').style.setProperty('--s-color', '#ffffff');
                        if(document.querySelector('.swiper-pagination-bullet')) {
                        
                            document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
                                b.classList.contains('swiper-pagination-bullet-active') ? b.style.backgroundColor = '#93cf50' : b.style.backgroundColor = '#ffffff';
                            })
                        }
                    } else if (e.wrapperEl.children[i].classList.contains('swiper-slide-active') && e.wrapperEl.children[i].classList.contains('blue-dark')) {
                        document.querySelector('.swiper-button-next').style.backgroundColor = '';
                        document.querySelector('.swiper-button-next').style.setProperty("--s-color", "#ffffff");
                        document.querySelector('.swiper-cont-next').style.setProperty('--s-color', '#ffffff');
                        if(document.querySelector('.swiper-pagination-bullet')) {
                        
                            document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
                                b.classList.contains('swiper-pagination-bullet-active') ? b.style.backgroundColor = '' : b.style.backgroundColor = '#ffffff'
                            })
                        }
                    } else if (e.wrapperEl.children[i].classList.contains('swiper-slide-active') && e.wrapperEl.children[i].classList.contains('blue-light')) {
                        document.querySelector('.swiper-button-next').style.backgroundColor = '';
                        document.querySelector('.swiper-button-next').style.setProperty("--s-color", "");
                        document.querySelector('.swiper-cont-next').style.setProperty('--s-color', '');
                        if(document.querySelector('.swiper-pagination-bullet')) {
                            document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
                                b.classList.contains('swiper-pagination-bullet-active') ? b.style.backgroundColor = '' : b.style.backgroundColor = ''
                            })
                        }
                    }
                }
            },
        },
    });
   

    swiperH.on('transitionStart', function (e) {
        for (let i = 0; i < e.wrapperEl.children.length; i++) {
            if (e.wrapperEl.children[i].classList.contains('swiper-slide-active') && e.wrapperEl.children[i].classList.contains('green-light')) {
                document.querySelector('.swiper-button-next').style.backgroundColor = '#93cf50';
                document.querySelector('.swiper-button-next').style.setProperty("--s-color", "");
                document.querySelector('.swiper-cont-next').style.setProperty('--s-color', '');
                if(document.querySelector('.swiper-pagination-bullet')) {
                
                    document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
                        b.classList.contains('swiper-pagination-bullet-active') ? b.style.backgroundColor = '#93cf50' : b.style.backgroundColor = '';
                    })
                }
            } else if (e.wrapperEl.children[i].classList.contains('swiper-slide-active') && e.wrapperEl.children[i].classList.contains('green-dark')) {
                document.querySelector('.swiper-cont-next').style.setProperty('--s-color', '#ffffff');
                document.querySelector('.swiper-button-next').style.setProperty("--s-color", "#ffffff");
                if(document.querySelector('.swiper-pagination-bullet')) {
                    document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
                        b.classList.contains('swiper-pagination-bullet-active') ? b.style.backgroundColor = '#93cf50' : b.style.backgroundColor = '#ffffff';
                    })
                }
            } else if (e.wrapperEl.children[i].classList.contains('swiper-slide-active') && e.wrapperEl.children[i].classList.contains('blue-dark')) {
                document.querySelector('.swiper-button-next').style.backgroundColor = '';
                document.querySelector('.swiper-button-next').style.setProperty("--s-color", "#ffffff");
                document.querySelector('.swiper-cont-next').style.setProperty('--s-color', '#ffffff');
                if(document.querySelector('.swiper-pagination-bullet')) {
                    document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
                        b.classList.contains('swiper-pagination-bullet-active') ? b.style.backgroundColor = '' : b.style.backgroundColor = '#ffffff'
                    })
                }
            } else if (e.wrapperEl.children[i].classList.contains('swiper-slide-active') && e.wrapperEl.children[i].classList.contains('blue-light')) {
                document.querySelector('.swiper-button-next').style.backgroundColor = '';
                document.querySelector('.swiper-button-next').style.setProperty("--s-color", "");
                document.querySelector('.swiper-cont-next').style.setProperty('--s-color', '');
                if(document.querySelector('.swiper-pagination-bullet')) {
                    document.querySelectorAll('.swiper-pagination-bullet').forEach(b => {
                        b.classList.contains('swiper-pagination-bullet-active') ? b.style.backgroundColor = '' : b.style.backgroundColor = ''
                    })
                }
            }
        }
    });

    gsap.fromTo(".c-swiper__item", { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: 0.5 })
    gsap.fromTo(".c-swiper__item2", { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: 1 })

    swiperH.on("slideChange", function () {
        gsap.fromTo(".c-swiper__item", { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: 0.5 })
        gsap.fromTo(".c-swiper__item2", { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: 1 })
    });


    let swiperT = [];
    if ($('.tabs-swiper').length) {
        $(".tabs-swiper").each(function (i) {
            $(this).addClass('ts-' + i);
            $(this).next('.swiper-controls').find('.swiper-pagination').addClass('ts-sp-' + i);
            $(this).next('.swiper-controls').find('.swiper-button-next').addClass('ts-sbn-' + i);
            swiperT[i] = new Swiper('.ts-' + i, {
                slidesPerView: 'auto',
                rewind: true,
                pagination: {
                    el: '.ts-sp-' + i,
                    clickable: true,
                    dynamicBullets: true,
                    dynamicMainBullets: 3
                },
                navigation: {
                    nextEl: '.ts-sbn-' + i,
                },
                on: {
                    afterInit: function (el) {
                        if (el.isLocked) { $('.ts-sp-' + i).parent().addClass('d-none'); }
                    },
                },
            });
            swiperT[i].on('lock', function () {
                $('.ts-sp-' + i).parent().addClass('d-none');
            }).on('unlock', function () {
                $('.ts-sp-' + i).parent().removeClass('d-none');
            });
        });
    }




    /////////////////////// INICIALIACION SELECT /////////////////////
    $('.select-oxiTemps').select2({
        minimumResultsForSearch: -1,
        width: '100%'
    });

    let mediaqueryListMD = window.matchMedia("(min-width: 980px)");
    if (mediaqueryListMD.matches) {
        function isTouchDevice() {
            return (
                "ontouchstart" in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0
            );
        }

        const isTouch = isTouchDevice();

        if (!isTouch) {

            let hoverTarget = document.querySelectorAll('.btn-primary, .btn-secondary, .btn-terciary, input[type="file"]');
            hoverTarget.forEach((el) => {
                let spanCursor = document.createElement('span');
                spanCursor.classList.add('cursor-custom');
                gsap.set(spanCursor, {
                    xPercent: -50,
                    yPercent: -50
                });
                el.appendChild(spanCursor);

                document.addEventListener('mousemove', (e) => {
                    elemRect = el.getBoundingClientRect(),
                        offsetT = e.clientY - elemRect.top;
                    offsetL = e.clientX - elemRect.left;
                    gsap.to(spanCursor, { x: offsetL, y: offsetT, duration: 0.3 });
                });

                el.addEventListener("mouseenter", () => {
                    gsap.set(spanCursor, { scale: 0 });
                    gsap.to(spanCursor, { scale: 1, duration: 0.2 });
                });
                el.addEventListener("mouseleave", () => {
                    gsap.to(spanCursor, { scale: 0, duration: .2 });
                });


            });
        }
    }
});

$('#text_input_span_id').click(function () {
    $("#file_input_id").trigger('click');
})
// bind file-input-form click action to text-input-form
$('#text_input_id').click(function () {
    $("#file_input_id").trigger('click');
})
// display file name in text-input-form    
$("#file_input_id").change(function () {
    $('#text_input_id').val(this.value.replace(/C:\\fakepath\\/i, ''))
})

/////////////////////// ANIMACIONES /////////////////////
let accordionReveal = gsap.utils.toArray(".c-accordion__nav");

accordionReveal.forEach((element, index) => {

    let target = element.querySelectorAll(".c-accordion__nav-item");
    let anim = gsap.from(
        target,
        {
            autoAlpha: 0,
            ease: "power4",
            stagger: 0.2,
            y: 20
        }
    );

    ScrollTrigger.create({
        trigger: element,
        start: "top 80%",
        // markers: true,
        toggleActions: "play none none reverse",
        animation: anim
    });
});

if (window.matchMedia("(min-width: 740px)").matches) {
    animations();
}

function animations() {

    let selector = document.querySelectorAll('[data-anim]');

    selector.forEach((element, index) => {

        let animName = element.getAttribute("data-anim");

        switch (animName) {
            case "fade-in":

                let fadeIn = gsap.from(element, {
                    autoAlpha: 0,
                    ease: "power4",
                    duration: 2
                });

                ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    toggleActions: "play none none none",
                    animation: fadeIn,
                    // markers: true
                });

                break;
            case "fade-in-up":

                let fadeInUp = gsap.from(element, {
                    autoAlpha: 0,
                    ease: "power4",
                    duration: 2,
                    y: 20
                });

                ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    toggleActions: "play none none none",
                    animation: fadeInUp,
                    // markers: true
                });

                break;
            case "fade-in-right":

                let fadeInRight = gsap.from(element, {
                    autoAlpha: 0,
                    ease: "power4",
                    duration: 2,
                    x: 20
                });

                ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    toggleActions: "play none none none",
                    animation: fadeInRight,
                    // markers: true
                });

                break;
            case "fade-in-down":

                let fadeInDown = gsap.from(element, {
                    autoAlpha: 0,
                    ease: "power4",
                    duration: 2,
                    y: -20
                });

                ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    toggleActions: "play none none none",
                    animation: fadeInDown,
                    // markers: true
                });

                break;
            case "fade-in-left":

                let fadeInLeft = gsap.from(element, {
                    autoAlpha: 0,
                    ease: "power4",
                    duration: 2,
                    x: -20
                });

                ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    toggleActions: "play none none none",
                    animation: fadeInLeft,
                    // markers: true
                });

                break;
            case "zoom-in":

                let zoomIn = gsap.fromTo(element, {
                    scale: 1.3,
                    duration: 2,
                    y: 100,
                    autoAlpha: 0
                },
                    {
                        scale: 1,
                        autoAlpha: 1,
                        duration: 1,
                        ease: "sine.out",
                        autoAlpha: 1,
                        y: 0
                    }
                );

                ScrollTrigger.create({
                    trigger: element,
                    start: "top 80%",
                    toggleActions: "play none none none",
                    animation: zoomIn,
                    // markers: true
                });

                break;
            default:

                // no animation F

                break;
        }

    });

}

/////////////////////// inputs head-appointment /////////////////////

if (document.querySelector('.head-appointment .form-control')) {
    document.querySelectorAll('.head-appointment .form-control').forEach(f => {
        f.addEventListener('focus', () => {
            f.parentElement.classList.add('focus')
        })
        f.addEventListener('blur', () => {
            if (f.value === "") {
                f.parentElement.classList.remove('focus')
            }
        })
    })
}

let swiperSc = new Swiper(".swiper-scroll", {
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 40,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    mousewheel: {
        releaseOnEdges: true,
    },
    on: {
        init: function () {
            setTimeout(function () {
                let currentPage = $(".swiper-scroll .swiper-slide a.active").parent();
                swiperSc.slideTo($(".swiper-scroll .swiper-slide").index(currentPage), 0);
            }, 0);
        },
    }
});
$('.swiper-scroll').bind('touchmove', false);
let swiperSum = new Swiper(".swiper-suministros", {
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 40,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    mousewheel: {
        releaseOnEdges: true,
    },
});
$('.swiper-suministros').bind('touchmove', false);

function closeModal() {
    document.querySelector('.contact-chat .email').classList.remove('expand')
    document.querySelector('body').classList.remove('backdrop')
    // Removemos el evento de clic fuera del modal después de cerrarlo
    window.removeEventListener('click', clickOutsideModal);
}

// Función que maneja el clic fuera del modal
function clickOutsideModal(event) {
    if (event.target === document.querySelector('body')) {
        closeModal();
    }
}
// console.log(sessionStorage, 'hola caracola')
window.onload = function exampleFunction() {
    // console.log(document.cookie, 'hola caracola')
    if (document.getElementById('gasesinfo')) {
        // console.log(document.cookie);
        const modal = new bootstrap.Modal('#gasesinfo');
        
        let soyprofesional =sessionStorage.getItem('soyprofesional');
    
        // Si no se ha guardado la elección en cookies, mostrar el modal
        if (soyprofesional === null) {
            modal.show();
        }
    
        const modalEl = document.getElementById('gasesinfo');
    
        const confirmCheckbox = modalEl.querySelector('#checksanitario');
        const rememberCheckbox = modalEl.querySelector('#chekcrecordar'); 
        const confirmBtn = modalEl.querySelector('#btnAceptar');
    
        confirmCheckbox.addEventListener('change', () => {
            confirmBtn.disabled = !confirmCheckbox.checked;
        });
    
        confirmBtn.onclick = () => {
            if (rememberCheckbox.checked) {
                sessionStorage.setItem('soyprofesional', 'true');
            }
            modal.hide();
            // console.log(sessionStorage, 'fin');
        };

    }

    const btnUp = document.querySelector('.btn-up');
    btnUp.addEventListener('click', () => {
        if (!document.querySelector("body").classList.contains('login')){
            smoother.scrollTo(0);
        } else {
            window.scrollTo(0,0);
        }
    });

    document.querySelector('.contact-chat .email').addEventListener('click', (el) => {
        document.querySelector('.contact-chat .email').classList.add('expand')
        document.querySelector('body').classList.add('backdrop')
        window.addEventListener('click', clickOutsideModal);
    })
    document.querySelector('.contact-chat .btn-close').addEventListener('click', (event) => {
        document.querySelector('.email').classList.remove('expand');
        event.stopPropagation();
        document.querySelector('body').classList.remove('backdrop');
    })
}

if (document.querySelector('.btn-up')!= null){
    window.onscroll = function() {
        scrollFunction();
    };

    function scrollFunction() {
        let scrollBtn = document.querySelector('.btn-up');
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            scrollBtn.style.display = "flex";
            document.querySelector('.from.btn').classList.add('move-up')
        } else {
            scrollBtn.style.display = "none";
            document.querySelector('.from.btn').classList.remove('move-up')
        }
    }
}

